import { render } from "./UserAgreeView.vue?vue&type=template&id=6030d5d5"
import script from "./UserAgreeView.vue?vue&type=script&lang=js"
export * from "./UserAgreeView.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__